import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditMenus from './EditMenus'
import ListMenus from './ListMenus'
import NewMenus from './NewMenus'

const AdminMenusRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListMenus /></PrivateRoute7>} />
        <Route path="edit-menu" element={<PrivateRoute7><EditMenus /></PrivateRoute7>} />
        <Route path="new-menu" element={<PrivateRoute7><NewMenus /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminMenusRoutes